import type { SupabaseClient } from "@supabase/supabase-js";
import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "./types/Api";

type ApiClientOptions = {
  supabase: SupabaseClient;
  baseUrl: string;
  requireAuthentication: boolean;
};

export class NetworkError extends Error {
  status: number;
  constructor({ title, status }: { title: string; status: number }) {
    super(title);
    this.name = "NetworkError";
    this.status = status;
  }
}

export const createApiClient = ({
  supabase,
  baseUrl,
  requireAuthentication,
}: ApiClientOptions) => {
  const middleware: Middleware = {
    onRequest: async ({ request }) => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (requireAuthentication && !session) {
        return Promise.reject(
          new NetworkError({
            title: "Unauthorized, sign in required",
            status: 401,
          }),
        );
      }

      request.headers.set("Accept", "application/json");
      if (session) {
        request.headers.set("Authorization", `Bearer ${session.access_token}`);
      }
      return request;
    },
  };

  const apiClient = createClient<paths>({ baseUrl, credentials: "include" });
  apiClient.use(middleware);
  return apiClient;
};
